<!-------Launch Banner----------->
<section>
  <div class="relative">
    <div class="relative">
      <img rel="preload" fetchpriority="high" as="image" src="assets/images/ESDP_Certification_Launch_1.webp" alt="ESDP Certification Launch" title="ESDP Certification Launch" class="w-full h-auto">
      <svg width="2880" height="300" viewBox="0 0 2880 392" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-full absolute bottom-[-4.1rem]">
        <path d="M2880 83.333C2224.88 500.156 804.08 -236.156 0 83.333V400H2880V83.333Z" fill="white"/>
      </svg>
    </div>

    <div class="absolute bottom-56 left-8 w-3/5  translate-x-[2%] translate-y-[40%] bg-transperantwhite p-6 rounded-2xl launch-event-banner-box-shadow">
      <div class="text-3xl font-bold tracking-wide text-primary">ESDP is Europe's first Supplier Diversity advocacy network,</div>
      <div class="mt-3 mb-4 tracking-wide">headquartered in <strong>Amsterdam</strong>, certifying, and connecting <strong>ethnic minority and immigrant-owned businesses</strong> with <strong>global and regional corporations.</strong> </div>
      <div class="tracking-wide">Our mission is to help our beneficiaries to sustain and grow by doing business with global corporates, committed to a more diverse & inclusive supply chain.</div>
      <div class="flex justify-center gap-5 items-center mt-5">
        <button mat-raised-button class="mat-blue !rounded-[50px] !px-7" (click)="goToCreateAccount()">Create Account</button>
        <div>Or</div>
        <button mat-raised-button class="mat-blue !rounded-[50px] !px-7" (click)="goToLogin()">Log In</button>
      </div>
    </div>
  </div>
</section>

<!--------What is esdp certification------------>
<section class="pb-16 bg-gradient-to-b from-white to-greytestimonial">
  <div class="text-white bg-primary p-9 rounded-2xl max-w-6xl 2xl:max-w-7xl mx-auto mt-[-14px] z-10 relative">
    <div class="flex items-center gap-4">
      <img src="assets/icons/esdp-logo.png" alt="Esdp Logo" title="Esdp Logo" class="w-6">
      <div class="text-2xl font-bold tracking-wide">What is ESDP Certification?</div>
    </div>
    <div class="ml-11 tracking-wide">
      <div class="mt-5 mb-4">
        <strong>Certification vs. Self-Registered Membership.</strong> Businesses that wish to be on our supplier database accessible by our Corporate Members can be either <strong>Certified Members or Self-Registered Members.</strong>
      </div>
      <div>
        By choosing to be a Certified Member, you can benefit, for a fee, from enhanced visibility to our Corporate Members and increased access to business opportunities.
      </div>
    </div>
  </div>
</section>

<!---Annual Membership Fee Structure-->
<section class="bg-greytestimonial">
  <div class="flex flex-row justify-between items-center bg-primary pl-[3.25rem] xl:pl-[7.5rem] pr-10 w-2/5 rounded-r-lg">
    <div class="text-white text-3xl font-bold tracking-wide">Fee Structure</div>
    <img src="assets/icons/esdp-logo.png" alt="Esdp Logo" title="Esdp Logo" class="w-11">
  </div>
  <div class="max-w-6xl 2xl:max-w-7xl mx-auto py-16">
     <div class="flex flex-row gap-8">
       <!-- Left side: ESDP Certification Fee Structure info -->
       <div class="bg-primary text-white rounded-2xl p-7 w-[30%] relative">
         <div class="text-3xl">ESDP Certification <br> <span class="font-bold tracking-wide">Fee Structure</span></div>
         <div class="tracking-wide w-3/4 my-3">(Non-refundable Processing Fee, exc. VAT 21%)</div>
       </div>

       <!-- Right side: Membership Cards -->
       <div class="w-[65%] flex gap-8">
         <!-- One Year Membership Card -->
         <div class="bg-white rounded-2xl p-8 w-[42%] membership-card">
           <div class="flex items-center gap-3 mb-8">
             <img src="assets/icons/esdp-logo.png" alt="ESDP Logo" class="w-6">
             <h3 class="text-xl font-bold text-gray-800">{{ membershipOptions.oneYear.title }}</h3>
           </div>
          
           <div class="flex flex-col justify-between h-full">
             <div *ngFor="let tier of membershipOptions.oneYear.tiers" class="border-b border-dotted border-gray-300 py-6 flex justify-between items-center">
               <div>
                 <div class="text-sm font-semibold text-gray-900">{{ tier.revenueRange }}</div>
                 <div class="text-xs text-gray-700">{{ tier.description }}</div>
               </div>
               <div class="text-4xl font-bold text-gray-800">{{ tier.amount }}</div>
             </div>
           </div>
        </div>

         <!-- Three Year Membership Card -->
         <div class="bg-white rounded-2xl p-8 w-[42%] membership-card">
           <div class="flex items-center gap-3 mb-8">
             <img src="assets/icons/esdp-logo.png" alt="ESDP Logo" class="w-6">
             <h3 class="text-xl font-bold text-gray-800">{{ membershipOptions.threeYear.title }}</h3>
           </div>
          
           <div class="flex flex-col justify-between h-full">
             <div *ngFor="let tier of membershipOptions.threeYear.tiers" class="border-b border-dotted border-gray-300 py-6 flex justify-between items-center">
               <div>
                 <div class="text-sm font-semibold text-gray-900">{{ tier.revenueRange }}</div>
                 <div class="text-xs text-gray-700">{{ tier.description }}</div>
               </div>
               <div class="text-4xl font-bold text-gray-800">{{ tier.amount }}</div>
             </div>
           </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!---certification Eligilibity------>
<section class="bg-primary py-16">
  <div class="flex flex-row justify-between items-center bg-white pl-[3.25rem] xl:pl-[7.5rem] pr-10 w-2/5 rounded-r-lg mb-8">
    <div class="text-primary text-3xl font-bold tracking-wide">Certification Eligibility</div>
    <img src="assets/icons/esdp-logo.png" alt="Esdp Logo" title="Esdp Logo" class="w-11">
  </div>
  <!-------Carousel Portion---------->
  <div class="max-w-6xl 2xl:max-w-7xl mx-auto">
    <div class="flex flex-row h-full">
      <div class="w-1/2 !rounded-l-xl">
        <owl-carousel-o [options]="certificationEligilibityOptions" class="eligilibility-carousel">
          <ng-container *ngFor="let slide of certificationEligiblityImages">
            <ng-template carouselSlide [id]="slide.id" >
              <img [src]="slide.image" [alt]="slide.alt" [title]="slide.title" class="!rounded-l-xl w-full h-[450px] object-cover">
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
       <div class="w-1/2 bg-white rounded-r-xl p-6 h-[450px]">
         <div class="text-primary text-2xl font-bold leading-8 pl-9">
           To be eligible for ESDP Certification, applicants must declare meeting all of these criteria:
         </div>
        <ul class="text-lg leading-5">
          <li class="pt-5 flex flex-row gap-3" *ngFor="let eligibility of certificationEligiblityText">
            <div class="flex-shrink-0">
              <img src="assets/icons/esdp-logo.png" alt="Esdp Logo" title="Esdp Logo" class="w-6 h-6 object-contain">
            </div>
            <span [innerHTML]="eligibility.eligilibityText"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!--------Ethnic Minority Definition--------------->
<section class="bg-white py-16">
  <div class="max-w-6xl 2xl:max-w-7xl mx-auto px-6">
    <div class="text-center mb-12">
      <h2 class="text-primary text-2xl font-bold leading-relaxed">
        "Ethnic minority and non-Western immigrant" for the purposes of this application shall mean individuals who wish to self-declare/self-identify as being from one of the below communities:
      </h2>
    </div>
    
    <div class="max-w-6xl mx-auto">
      <!-- Custom Grid Layout with 2 rows and 4 columns -->
      <div class="grid grid-cols-1 md:grid-cols-4 grid-rows-2 gap-6 h-[750px]">
        <!-- Western Asia - First row, first column -->
        <div class="bg-primary text-white rounded-lg p-6 flex flex-col col-start-1 row-start-1">
          <h3 class="text-xl font-bold mb-4">Western Asia:</h3>
          <ul class="space-y-1 text-sm flex-1">
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Turks</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Kurds</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Iraqi diaspora (including Arabs, Assyrians, Armenians, Shabaks, Mandeans, Kawliya and Yezids)</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Lebanese diaspora</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Syrian diaspora (including Arabs, Assyrians, Kurds, Armenians, Arameans, Turks, Mhallami and Yezidis.)</li>
          </ul>
        </div>

        <!-- Latin America & Caribbean - Spans 2 rows, second column -->
        <div class="text-white rounded-lg p-6 row-span-2 col-start-2 row-start-1 flex flex-col h-full" style="background-color: #5880ec;">
          <h3 class="text-xl font-bold mb-4">Latin America & Caribbean:</h3>
          <ul class="space-y-1 text-sm flex-1">
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Belize</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Costa Rica</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> El Salvador</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Guatemala</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Honduras</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Mexico</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Nicaragua</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Panama</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Argentina</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Bolivia</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Brazil</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Chile</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Colombia</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Ecuador</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> French Guiana</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Guyana</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Paraguay</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Peru</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Suriname</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Uruguay</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Venezuela</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Cuba</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Dominican Republic</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Haiti</li>
          </ul>
        </div>

        <!-- South Asia - First row, third column -->
        <div class="bg-primary text-white rounded-lg p-6 flex flex-col col-start-3 row-start-1">
          <h3 class="text-xl font-bold mb-4">South Asia:</h3>
          <ul class="space-y-1 text-sm flex-1">
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Indians</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Pakistanis</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Bangladeshi</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Sri Lankans</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Nepalese</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Afghans</li>
          </ul>
        </div>

        <!-- East Asia - First row, fourth column -->
        <div class="bg-primary text-white rounded-lg p-6 flex flex-col col-start-4 row-start-1">
          <h3 class="text-xl font-bold mb-4">East Asia:</h3>
          <ul class="space-y-1 text-sm flex-1">
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Chinese</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Japanese</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Koreans</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Mongolians</li>
          </ul>
        </div>

        <!-- Africa - Second row, first column -->
        <div class="text-white rounded-lg p-6 flex flex-col col-start-1 row-start-2" style="background-color: #5880ec;">
          <h3 class="text-xl font-bold mb-4">Africa:</h3>
          <ul class="space-y-1 text-sm flex-1">
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> North Africans (North African Arabs, Egyptian Copts, Moroccans, Algerians, Lybia, Tunisia Berbers)</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Horn Africans (Somalis, Ethiopians, Eritreans, Djiboutians, and the Northern Sudanese)</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Sub-Saharan Africans (Afro-Caribbeans, African Americans, Afro-Latinos and others by descent)</li>
          </ul>
        </div>
        
        <!-- Southeast Asia - Second row, third column (below South Asia) -->
        <div class="text-white rounded-lg p-6 flex flex-col col-start-3 row-start-2" style="background-color: #5880ec;">
          <h3 class="text-xl font-bold mb-4">Southeast Asia:</h3>
          <ul class="space-y-1 text-sm flex-1">
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Filipinos</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Indonesians</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Thais</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Vietnamese</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Cambodians</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Burmese</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Malaysian</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Singaporean</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Timorese</li>
            <li class="flex items-start gap-2"><img src="assets/icons/Arrow White.png" alt="arrow" class="w-3 h-3 flex-shrink-0 mt-1"> Laotian</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <!--------Definations--------------->
<!-- <section class="bg-greytestimonial pt-16">
  <div class="flex flex-row justify-between items-center bg-primary pl-[3.25rem] xl:pl-[7.5rem] pr-10 w-2/5 rounded-r-lg">
    <div class="text-white text-3xl font-bold tracking-wide">Definitions</div>
    <img src="assets/icons/esdp-logo.png" alt="Esdp Logo" title="Esdp Logo" class="w-11">
  </div>
  <div class="max-w-6xl 2xl:max-w-7xl mx-auto mt-16 pb-16">
    <div class="flex flex-row flex-grow items-center gap-16">
      <div class="flex flex-col items-center justify-between rounded-t-lg" *ngFor="let defination of definationArray">
        <img [src]="defination.src" [alt]="defination.alt" [title]="defination.title" class="rounded-t-xl">
        <mat-card class="w-full py-7 text-center text-primary text-xl font-bold !rounded-b-xl h-24">{{defination.text}}</mat-card>
      </div>
    </div>
  </div>
</section> -->

<!----Processing of Data------------->
<section class="bg-primary py-16">
  <div class="flex flex-row justify-between items-center bg-white pl-[3.25rem] xl:pl-[7.5rem] pr-10 w-2/5 rounded-r-lg mb-8">
    <div class="text-primary text-3xl font-bold tracking-wide">Processing of your Data</div>
    <img src="assets/icons/esdp-logo.png" alt="Esdp Logo" title="Esdp Logo" class="w-11">
  </div>
  <div class="max-w-6xl 2xl:max-w-7xl mx-auto bg-white rounded-xl p-7 text-lg">
    <p class="mb-8">Please note that some special categories of data, constituting sensitive data, are processed by us as part of our purpose to provide assistance to the most discriminated ethnic minorities who run businesses and give them visibility to our Corporate Members who are committed to equal opportunities, diversity and inclusion.</p>
    <p class="mb-8">To find out, amongst others, specifically why and how we process your data, please read this entire section along with our <a href="https://esdp-org.eu/privacy/?_gl=1*1ozeso6*_ga*NDQyMDMxMTM0LjE2OTk1MjE5NTI.*_ga_KNQDF1YSTT*MTcxMTAzMDkzOC45NC4xLjE3MTEwMzEwNjUuMC4wLjA."
      target="_blank" class="underline underline-offset-2 cursor-pointer">Privacy Policy</a> and the <a href="https://esdp-org.eu/faqs/?_gl=1*1f01e3n*_ga*NDQyMDMxMTM0LjE2OTk1MjE5NTI.*_ga_KNQDF1YSTT*MTcxMTAzMDkzOC45NC4xLjE3MTEwMzEwNjguMC4wLjA."
      target="_blank" class="underline underline-offset-2 cursor-pointer">FAQs.</a></p>
    <strong>Terms used in this document</strong>
    <p  class="mt-8">The term "ethnic minority" is used here. We understand, accept and embrace the fact that human beings constitute a single race. For the sake of this document and our actions, we must acknowledge, without condoning or agreeing with it, the fact that large sections of the population are discriminated against due to what is perceived as a different "race" / “ethnicity”. We also note that "race" is a term used by laws and constitutions in Europe and beyond to refer to different groups of human beings. As such, in order to identify the groups of people who are subject to discrimination, based on their non-European white physical appearance or non-white European sounding name, we may use the term "race", "racial", "ethnicity" and "ethnic" in our communication.</p>
  </div>
</section>

<!----Testimonials----------->
<section class="py-16 bg-greytestimonial">
  <div class="max-w-6xl 2xl:max-w-7xl mx-auto ">
    <owl-carousel-o [options]="testimonialsOptions" class="testimonial-carousel">
      <ng-container *ngFor="let testimonial of testimonials">
        <ng-template carouselSlide [id]="testimonial.id" >
          <mat-card class="p-7 !rounded-2xl my-4 mx-6">
            <div class="flex flex-row gap-6 items-start grow h-24">
              <div class="flex flex-col gap-1 w-3/4">
                <div class="text-2xl font-bold">{{testimonial.name}}</div>
                <div class="text-primary text-sm font-bold">{{testimonial.titleCompany}}</div>
              </div>
              <div class="w-1/4">
                <img [src]="testimonial.image" 
                     [alt]="testimonial.alt" 
                     [title]="testimonial.title" 
                     class="w-full aspect-square object-cover rounded-full"
                     [style.object-position]="testimonial.name === 'Kemo Camara' ? 'center 25%' : 
                                             testimonial.name === 'Surja Bose' ? 'center 15%' :
                                             'center center'"
                     [style.transform]="testimonial.name === 'Shirley Billot' ? 'scale(1.2)' : 'scale(1)'">
              </div>
            </div>
            <div class="font-bold text-md pt-5 leading-loose h-[28rem]"> {{testimonial.testimonial}} </div>
          </mat-card>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>
